import styled from "@mui/material/styles/styled";
import { DateRangePicker, TimeRangePicker, DatePicker } from "rsuite";
const DatePickerStyled = styled(DatePicker)`
   > .rs-input-group.rs-picker-input-group {
    height: 40px;
    border-radius: 8px;
    background-color: var(--mui-palette-elevation0-transparent);
    padding: 10px;
    border: 0;
  }

  .rs-input {
    background-color: transparent;
    padding: 0;
    font-size: 16px;
    height: 100%;
    color: var(--mui-palette-elevation0-contrast);
    font-variant-numeric: lining-nums tabular-nums;
    text-overflow: ellipsis;
    
  }
  .rs-input-group.rs-input-group-inside .rs-input-group-addon {
    padding: 0
  }
  .rs-btn-close:hover svg path,
  .rs-btn-close:focus svg path,
  .rs-btn-close svg path   {
    stroke: var(--mui-palette-elevation0-contrast);
  }
  .rs-calendar-header-title-date {
    font-size: 16px;
  }
  .MuiSvgIcon-root {
    color: var(--mui-palette-elevation0-contrast);
  }
`;
const DateRangePickerStyled = styled(DateRangePicker)`
  width: 285px;

  > .rs-picker-input-group {
    height: 40px;
    border-radius: 8px;
    background-color: var(--mui-palette-elevation0-transparent);
    padding: 10px;
    border: 0 ;
  }

  .rs-input {
    background-color: transparent;
    padding: 0;
    font-size: 16px;
    height: 100%;
    color: var(--mui-palette-elevation0-contrast);
    font-variant-numeric: lining-nums tabular-nums;
    text-overflow: ellipsis;
    
  }

  .rs-input-group.rs-input-group-inside .rs-input-group-addon {
    padding: 0
  }
  .MuiSvgIcon-root {
    color: var(--mui-palette-elevation0-contrast);
  }
  .rs-btn-close:hover svg path,
  .rs-btn-close:focus svg path,
  .rs-btn-close svg path   {
    stroke: var(--mui-palette-elevation0-contrast);
  }
  

  .rs-calendar-header-title-date {
    font-size: 16px;
  }

`;
const TimeRangePickerStyled = styled(TimeRangePicker)`
  width: 150px;
  > .rs-picker-input-group {
    height: 40px;
    border-radius: 8px;
    background-color: var(--mui-palette-elevation0-transparent);
    padding: 10px;
    border: 0;
  }

  .rs-input {
    background-color: transparent;
    padding: 0;
    font-size: 16px;
    height: 100%;
    color: var(--mui-palette-elevation0-contrast);
    font-variant-numeric: lining-nums tabular-nums;
    text-overflow: ellipsis;
    
  }

  .rs-input-group-addon {
    display: none;
  }

  .rs-calendar-header-title-date {
    font-size: 16px;
  }
`;
export {
  DatePickerStyled,
  DateRangePickerStyled,
  TimeRangePickerStyled
};
